import React, { FC, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/pro-light-svg-icons';
import classNames from 'classnames';
import styles from './index.module.scss';
import { trackRGContact } from 'src/segment/events';

interface Props {
  email: string;
  className?: string;
  title: string;
  subject: string;
  body: string;
}

export const MailToLink: FC<Props> = props => {
  const { className, email, title, subject, body } = props;
  const onClick = useCallback(() => trackRGContact(), []);
  return (
    <a
      href={`mailto:${email}?subject=${subject}&body=${body}`}
      className={classNames(styles.link, className)}
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faEnvelope} />
      <span>{title}</span>
    </a>
  );
};

export default MailToLink;
